/**
 * Global auth interceptor - signs user out when authentication is missing or expired (401).
 * A 403 means the session is valid but the current role cannot perform that action.
 * Import this file once in App.js as a side-effect.
 */
import axios from "axios";
import cookie from "react-cookies";

// Flag to prevent multiple logout redirects
let isLoggingOut = false;

function handleAuthFailure() {
  // Only sign out if the user is actually logged in
  if (!cookie.load("session-id-qt")) return;
  if (isLoggingOut) return;
  isLoggingOut = true;

  // Clear auth cookies (mirrors the logout in /auth/logout)
  cookie.remove("session-id-qt", { path: "/" });
  cookie.remove("ctName", { path: "/" });
  cookie.remove("localsessionid", { path: "/" });
  cookie.remove("promocode", { path: "/" });

  // Clear localStorage
  localStorage.clear();

  // Redirect to login
  window.location.href = "/";
}

// Axios global interceptor - only 401 is an authentication failure.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401) {
      handleAuthFailure();
    }
    return Promise.reject(error);
  }
);

// Patch global fetch with the same authentication semantics.
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);
  if (response.status === 401) {
    handleAuthFailure();
  }
  return response;
};
